module.exports = __webpack_public_path__ + "img/avatar5.8606408c.png";